import beforeEnter from '../utils'

export default {
  path: '/dicomvix/:id',
  component: () => import('@/App.vue'),
  beforeEnter: (to, from, next) => beforeEnter(to, from, next),
  children: [
    {
      path: '',
      component: () => import('@/pages/Layout.vue'),
      children: [
        {
          path: 'login',
          name: 'medico',
          component: () => import('@/pages/Dicomvix/Login.vue')
        },
        {
          path: '',
          name: 'dicomvix',
          component: () => import('@/pages/Dicomvix/Home.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'laudo',
          name: 'laudo',
          component: () => import('@/pages/Dicomvix/Laudo.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'agenda',
          name: 'agenda',
          component: () => import('@/pages/Dicomvix/AgendaMedico.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'repasse',
          name: 'repasse',
          component: () => import('@/pages/Dicomvix/Repasse.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'user',
          name: 'userMedico',
          component: () => import('@/pages/Dicomvix/Medico.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'pacsreporting',
          name: 'pacsreporting',
          component: () => import('@/pages/Dicomvix/Laudo.vue'),
          meta: {
            requiresAuth: true
          }
        }
      ]
    }
  ]
}
